import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from './locales/en/common.json';
import nav from './locales/en/nav.json';
import home from './locales/en/home.json';
import features from './locales/en/features.json';
import howItWorks from './locales/en/how-it-works.json';
import pricing from './locales/en/pricing.json';
import faq from './locales/en/faq.json';
import download from './locales/en/download.json';
import changelog from './locales/en/changelog.json';
import auth from './locales/en/auth.json';
import account from './locales/en/account.json';
import legal from './locales/en/legal.json';
import errors from './locales/en/errors.json';
import seo from './locales/en/seo.json';
import { DEFAULT_NS, FALLBACK_LANGUAGE, NAMESPACES } from './namespaces';

const resources = {
  en: { common, nav, home, features, 'how-it-works': howItWorks, pricing, faq, download, changelog, auth, account, legal, errors, seo },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: FALLBACK_LANGUAGE,
  fallbackLng: FALLBACK_LANGUAGE,
  defaultNS: DEFAULT_NS,
  ns: NAMESPACES,
  interpolation: { escapeValue: false },
  returnNull: false,
});

function applyDir(lng: string) {
  document.documentElement.setAttribute('dir', i18n.dir(lng));
  document.documentElement.setAttribute('lang', lng);
}

applyDir(FALLBACK_LANGUAGE);
i18n.on('languageChanged', applyDir);

export { i18n };
export type Resources = (typeof resources)['en'];
